var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  id: "itemPedido",
                  options: _vm.items,
                  label: "nombre"
                },
                on: { input: _vm.inputItem, search: _vm.searchItems },
                model: {
                  value: _vm.form.item,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "item", $$v)
                  },
                  expression: "form.item"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "itemPedido" } }, [_vm._v("Ítem*")])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "cantidadPedido",
                  vMoney: "",
                  format: _vm.decimal
                },
                model: {
                  value: _vm.form.cantidad,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "cantidad", $$v)
                  },
                  expression: "form.cantidad"
                }
              },
              [_c("span", [_vm._v("Cantidad")])]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "cantidadPedido", vMoney: "", format: _vm.money },
                model: {
                  value: _vm.form.precio,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "precio", $$v)
                  },
                  expression: "form.precio"
                }
              },
              [_c("span", [_vm._v("Precio")])]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  readonly: "",
                  id: "cantidadPedido",
                  value: _vm.total,
                  vMoney: "",
                  format: _vm.money
                }
              },
              [_c("span", [_vm._v("Total")])]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c("button", { staticClass: "btn-success", on: { click: _vm.aceptar } }, [
        _c("i", { staticClass: "fa fa-check" }),
        _c("span", [_vm._v("Aceptar")])
      ]),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn-danger btn--text", on: { click: _vm.cancelar } },
        [
          _c("i", { staticClass: "fa fa-ban" }),
          _c("span", [_vm._v("Cancelar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h5", [_vm._v("Ítem de pedido")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-214db4be", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-214db4be","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ItemPedido.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-214db4be","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ItemPedido.vue
// module chunks = 0